"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 10,
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1537_292)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.88897 8.14453L5.72296 1.03516C5.40401 0.488281 4.59913 0.488281 4.27803 1.03516L0.113972 8.14453C-0.206536 8.68945 0.192663 9.375 0.835065 9.375H9.1671C9.80694 9.375 10.2073 8.69141 9.88897 8.14453ZM4.53155 3.28125C4.53155 3.02246 4.74151 2.8125 5.0003 2.8125C5.25909 2.8125 5.46905 3.02344 5.46905 3.28125V5.78125C5.46905 6.04004 5.25909 6.25 5.01788 6.25C4.77667 6.25 4.53155 6.04102 4.53155 5.78125V3.28125ZM5.0003 8.125C4.66124 8.125 4.38624 7.85 4.38624 7.51094C4.38624 7.17188 4.66104 6.89687 5.0003 6.89687C5.33956 6.89687 5.61436 7.17188 5.61436 7.51094C5.61358 7.84961 5.34014 8.125 5.0003 8.125Z",
  fill: "#FFAF36"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1537_292"
}, /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 10,
  fill: "white"
}))));
var _default = exports.default = SvgComponent;